import React, { useEffect, useRef, useState } from "react";
import Footer from "../Footer";
import Header from "../Header";
import { logofloating } from "../Image";
import anime from "animejs";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { apiCall, mediaUrl } from "../util";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { setTopSpaceHeight } from "../custom";
const DoctorProfilePage = () => {
  const animatedRef = useRef(null);
  const location = useLocation();
  const doctorId = location.state?.doctorId;
  const [doctor, setDoctor] = useState([]);
  const [about, setAbout] = useState([]);
  const [experience, setExperience] = useState([]);
  const [awards, setAwards] = useState([]);
  const [publication, setPublication] = useState([]);
  const [research, setResearch] = useState([]);
  const [education, setEducation] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [imageLoaded, setImageLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (animatedRef.current) {
      anime({
        targets: animatedRef.current.children,
        opacity: [0, 1],
        translateX: [-30, 0],
        duration: 800,
        delay: anime.stagger(300),
        easing: "easeOutQuad",
      });
    }
  }, []);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      setLoading(true);
      try {
        const doctorResponse = await axios.post(apiCall + "doctor/view", {
          id: doctorId,
        });
        setDoctor(doctorResponse.data);
        setAbout(doctorResponse.data.about);
        setExperience(doctorResponse.data.experience);
        setAwards(doctorResponse.data.awards);
        setPublication(doctorResponse.data.publication);
        setResearch(doctorResponse.data.research);
        setEducation(doctorResponse.data.education);
        // Set active tab based on the fetched data
        if (doctorResponse.data?.about) {
          setActiveTab("tab_eight1");
        } else if (doctorResponse.data?.experience) {
          setActiveTab("tab_eight2");
        } else if (doctorResponse.data?.awards) {
          setActiveTab("tab_eight3");
        } else if (doctorResponse.data?.publication) {
          setActiveTab("tab_eight4");
        } else if (doctorResponse.data?.research) {
          setActiveTab("tab_eight5");
        } else {
          setActiveTab(""); // No active tab if all are empty
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };
    fetchDepartmentData();
  }, [doctorId]);

  const experienceArray =
    typeof experience === "string" ? JSON.parse(experience) : [];
  const awardsArray = typeof awards === "string" ? JSON.parse(awards) : [];
  const publicationArray =
    typeof publication === "string" ? JSON.parse(publication) : [];
  const researchArray =
    typeof research === "string" ? JSON.parse(research) : [];
  const educationArray =
    typeof education === "string" ? JSON.parse(education) : [];

useEffect(() => {
    if (typeof setTopSpaceHeight === "function") {
      setTopSpaceHeight();
    }
  }, []);

  return (
    <>
      <Header />

      <section className="top-space-margin position-relative pt-60px pb-60px page-title-big-typography bg-sg-light-gradient">
        <img src={logofloating} className="floating-logo" alt="floating-logo" />
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 col-sm-12 position-relative"
              ref={animatedRef}
            >
              <div className="d-flex gap-5 align-items-center">
                {/* Image Skeleton Loader */}
                {!imageLoaded && (
                  <Skeleton
                    height={350}
                    width={300}
                    style={{ borderRadius: "0px 60px 0px 60px" }}
                    baseColor="#f5f5f5"
                    highlightColor="#e0e0e0"
                  />
                )}

                {doctor?.image && (
                  <img
                    src={`${mediaUrl}/${doctor.image}`}
                    className="img-fluid sg-img-radius object-fit-cover box-shadow-quadruple-large border-white border"
                    alt="Doctor Image"
                    style={{
                      width: "300px",
                      height: "350px",
                      objectFit: "cover",
                      display: imageLoaded ? "block" : "none",
                    }}
                    onLoad={() => setImageLoaded(true)} // Set loaded state when image loads
                  />
                )}

                <div>
                  {/* Name Skeleton Loader */}
                  <h5 className="fw-700 text-dark-gray mb-10px">
                    {doctor?.name ? doctor.name : <Skeleton width={180} />}
                  </h5>

                  {/* Department Skeleton Loader */}
                  <a href="#" className="mb-0 fw-600 fs-18 text-base-color">
                    {doctor?.department_id ? (
                      <>
                        <i className="feather icon-feather-arrow-up-right"></i>
                        {doctor.department?.name}
                      </>
                    ) : (
                      <Skeleton width={150} />
                    )}
                  </a>

                  {/* Designation Skeleton Loader */}
                  <p className="text-base-color fw-600 fs-18 mb-20px">
                    {doctor?.designationid ? (
                      doctor.designation?.designation
                    ) : (
                      <Skeleton width={150} />
                    )}
                  </p>

                  <div>
                    {/* Experience Skeleton Loader */}
                    {doctor?.year_of_experience ? (
                      <p className="m-0 text-dark-gray fw-600">
                        <i className="fa-solid fa-briefcase-medical me-1"></i>
                        {doctor.year_of_experience}+ Years Experience
                      </p>
                    ) : doctor?.year_of_experience === null ? null : (
                      <div>
                        <Skeleton width={180} />
                      </div>
                    )}
                    {educationArray && educationArray.length > 0 ? (
                      <p className="m-0 text-dark-gray fw-600">
                        <i className="fa-solid fa-graduation-cap me-1"></i>
                        {educationArray.join(", ")}
                      </p>
                    ) : educationArray.length === 0 ? null : (
                      <div className="m-0 text-dark-gray fw-600">
                        <Skeleton width={180} />
                      </div>
                    )}
                  </div>

                  {/* Appointment Button Skeleton */}
                  {doctor?.hasAppointment ===
                  0 ? null : doctor?.hasAppointment ? (
                    <a
                      href={`#appointment/${doctor.id}`}
                      className="btn rounded btn-large btn-switch-text btn-base-color left-icon d-table d-lg-inline-block mt-25px"
                    >
                      <span>
                        <span>
                          <i className="fa-solid fa-calendar-alt"></i>
                        </span>
                        <span
                          className="btn-double-text"
                          data-text="Book an Appointment"
                        >
                          Book an Appointment
                        </span>
                      </span>
                    </a>
                  ) : (
                    <Skeleton width={200} height={40} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {(about || experience || awards || publication || research) && (
        <section className="bg-white -bg-sg-light-gradient pb-0 pt-0">
          <div className="tab-style-08 border-bottom border-color-extra-medium-gray bg-white box-shadow-quadruple-large">
            <div className="container">
              <ul className="nav nav-tabs border-0 fw-500 fs-18 text-center">
                {loading ? (
                  <>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                    <li className="nav-item">
                      <Skeleton width="100%" height={56} />
                    </li>
                  </>
                ) : (
                  <>
                    {about && (
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-600 ${
                            activeTab === "tab_eight1" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab_eight1")}
                          style={{ width: "100%" }}
                        >
                          About
                          <span className="tab-border bg-base-color"></span>
                        </button>
                      </li>
                    )}
                    {experience && (
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-600 ${
                            activeTab === "tab_eight2" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab_eight2")}
                          style={{ width: "100%" }}
                        >
                          Experience
                          <span className="tab-border bg-base-color"></span>
                        </button>
                      </li>
                    )}
                    {awards && (
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-600 ${
                            activeTab === "tab_eight3" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab_eight3")}
                          style={{ width: "100%" }}
                        >
                          Achievements & Awards
                          <span className="tab-border bg-base-color"></span>
                        </button>
                      </li>
                    )}
                    {publication && (
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-600 ${
                            activeTab === "tab_eight4" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab_eight4")}
                          style={{ width: "100%" }}
                        >
                          Publications
                          <span className="tab-border bg-base-color"></span>
                        </button>
                      </li>
                    )}
                    {research && (
                      <li className="nav-item">
                        <button
                          className={`nav-link fw-600 ${
                            activeTab === "tab_eight5" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab_eight5")}
                          style={{ width: "100%" }}
                        >
                          Research Projects
                          <span className="tab-border bg-base-color"></span>
                        </button>
                      </li>
                    )}
                  </>
                )}
              </ul>
            </div>
          </div>
          <div className="container">
            <div className="row row pt-4 pb-4">
              <div className="col-12 tab-style-08">
                <div className="tab-content">
                  {loading ? (
                    <>
                      <h5 className="fw-600 fw-bold">
                        <Skeleton width="30%" height={50} />
                      </h5>
                      <p>
                        <Skeleton count={5} height={30} />
                      </p>
                    </>
                  ) : (
                    <>
                      {about && (
                        <div
                          className={`tab-pane fade in ${
                            activeTab === "tab_eight1" ? "show active" : ""
                          }`}
                          id="tab_eight1"
                        >
                          <div className="row align-items-center justify-content-center g-lg-0">
                            <div className="col-xl-12 col-lg-12 text-center text-md-start text-dark-gray">
                              <h5 className="fw-600 fw-bold">
                                <i className="fa-solid fa-user-doctor me-1 text-base-color"></i>
                                About {doctor.name}
                              </h5>
                              <p>{about}</p>
                            </div>
                          </div>
                        </div>
                      )}

                      {experience && (
                        <div
                          className={`tab-pane fade in ${
                            activeTab === "tab_eight2" ? "show active" : ""
                          }`}
                          id="tab_eight2"
                        >
                          <div className="row align-items-center justify-content-center g-lg-0">
                            <div className="col-xl-12 col-lg-12 text-center text-md-start text-dark-gray">
                              <h5 className="fw-600 fw-bold">
                                <i className="fa-solid fa-stethoscope text-base-color me-1"></i>
                                Experience
                              </h5>
                              <ul className="list-style-04 fw-500">
                                {Array.isArray(experienceArray)
                                  ? experienceArray.map((item, index) => (
                                      <li key={index}>{item}</li>
                                    ))
                                  : null}
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}

                      {awards && (
                        <div
                          className={`tab-pane fade in ${
                            activeTab === "tab_eight3" ? "show active" : ""
                          }`}
                          id="tab_eight3"
                        >
                          <div className="row align-items-center justify-content-center g-lg-0">
                            <div className="col-xl-12 col-lg-12 text-center text-md-start text-dark-gray">
                              <h5 className="fw-600 fw-bold">
                                <i className="fa-solid fa-award text-base-color me-1"></i>
                                Achievements & Awards
                              </h5>
                              <ul className="list-style-04 fw-500">
                                {Array.isArray(awardsArray)
                                  ? awardsArray.map((item, index) => (
                                      <li key={index}>{item}</li>
                                    ))
                                  : null}
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}

                      {publication && (
                        <div
                          className={`tab-pane fade in ${
                            activeTab === "tab_eight4" ? "show active" : ""
                          }`}
                          id="tab_eight4"
                        >
                          <div className="row align-items-center justify-content-center g-lg-0">
                            <div className="col-xl-12 col-lg-12 text-center text-md-start text-dark-gray">
                              <h5 className="fw-600 fw-bold">
                                <i className="fa-regular fa-file-lines text-base-color me-1"></i>
                                Publications
                              </h5>
                              <ul className="list-style-04 fw-500">
                                {Array.isArray(publicationArray)
                                  ? publicationArray.map((item, index) => (
                                      <li key={index}>{item}</li>
                                    ))
                                  : null}
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}

                      {research && (
                        <div
                          className={`tab-pane fade in ${
                            activeTab === "tab_eight5" ? "show active" : ""
                          }`}
                          id="tab_eight5"
                        >
                          <div className="row align-items-center justify-content-center g-lg-0">
                            <div className="col-xl-12 col-lg-12 text-center text-md-start text-dark-gray">
                              <h5 className="fw-600 fw-bold">
                                <i className="fa-regular fa-bookmark text-base-color me-1"></i>
                                Research Projects
                              </h5>
                              <ul className="list-style-04 fw-500">
                                {Array.isArray(researchArray)
                                  ? researchArray.map((item, index) => (
                                      <li key={index}>{item}</li>
                                    ))
                                  : null}
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <Footer />
    </>
  );
};

export default DoctorProfilePage;
